import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { createMetaManager } from 'vue-meta'
import "bootstrap"
import Notifications from '@kyvg/vue3-notification'
import { createGtm } from '@gtm-support/vue-gtm'
import { createApolloProvider } from '@vue/apollo-option'
import { ApolloClient, InMemoryCache } from '@apollo/client/core'

const app = createApp(App)
const metaManager = createMetaManager();

app.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_GOOGLE_RECAPTCHA,
  // useEnterprise: true,
  // autoHideBadge: true
})

app.use(
  createGtm({
    id: ["GTM-K5H9M4Q"], // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
    defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
    compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
    enabled: process.env.VUE_APP_ENABLE_GTM === 'true' ? true : false, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: false, // Whether or not display console logs debugs (optional)
  }),
)

app.use(store)
app.use(metaManager)
app.use(router)
app.use(Notifications)


const cache = new InMemoryCache()
const apolloClient = new ApolloClient({
  cache,
  uri: process.env.VUE_APP_APOLLO_ENGINE_SERVICE + '/api/graphql',
})
app.use(createApolloProvider({
  defaultClient: apolloClient,
}))


app.mount('#app')
